import type { FC } from 'react';
import { Accordion, AccordionItem } from '@carbon/react';
import {
  LayoutSettings,
  RailSectionTitle,
  countVisible,
} from 'components/workspace-cards';
import { CARDS, type CardVisibility } from './columns';
import {
  RailFilters,
  type FilterTable,
  type TableFilters,
  type TableRows,
  type WorkspaceFilters,
} from './filters';
import styles from './page.module.scss';

export const Rail: FC<{
  visible: CardVisibility;
  onChange: (next: CardVisibility) => void;
  filters: WorkspaceFilters;
  rows: Partial<Record<FilterTable, TableRows>>;
  onFiltersChange: (table: FilterTable, next: TableFilters) => void;
}> = ({ visible, onChange, filters, rows, onFiltersChange }) => (
  <aside className={styles.rail}>
    <Accordion className={styles.accordion}>
      <AccordionItem
        open
        title={
          <RailSectionTitle
            label="Layout Settings"
            count={countVisible(visible, [...CARDS])}
          />
        }
      >
        <LayoutSettings
          groups={[{ legend: 'Cards', items: [...CARDS] }]}
          visible={visible}
          idPrefix="tsw-toggle-"
          onToggle={(card, shown) => onChange({ ...visible, [card]: shown })}
          onToggleGroup={(ids, shown) =>
            onChange(Object.fromEntries(ids.map((card) => [card, shown])))
          }
        />
      </AccordionItem>
      <RailFilters filters={filters} rows={rows} onChange={onFiltersChange} />
    </Accordion>
  </aside>
);
